import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Approve from '@wix/da-ds/pkg/Icons/24x24/Approve';
import verificationReminderStyles from './VerificationReminder.scss';
export var VerificationResent = function (_a) {
    var email = _a.email;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(verificationReminderStyles['root'], verificationReminderStyles['sent']) },
        React.createElement("div", { className: verificationReminderStyles['check'] },
            React.createElement(Approve, { customSizable: true })),
        React.createElement("div", { className: verificationReminderStyles['text'] }, t('siteHeader.verification.sent')),
        React.createElement("div", { className: verificationReminderStyles['email'], title: email }, email)));
};
VerificationResent.displayName = 'VerificationResent';
export default VerificationResent;
//# sourceMappingURL=VerificationResent.js.map